<template>
  <button @click="toggleBookmark" :class="{ 'is-bookmarked': isBookmarked }">
    <i :class="isBookmarked ? 'fas fa-bookmark' : 'far fa-bookmark'"></i>
  </button>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    initialIsBookmarked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isBookmarked: this.initialIsBookmarked
    }
  },
  methods: {
    async toggleBookmark() {
      try {
        const url = this.isBookmarked 
          ? `/unbookmark/${this.type}/${this.id}`
          : `/bookmark/${this.type}/${this.id}`;
        
        const response = await axios.post(url);
        
        if (response.data.success) {
          this.isBookmarked = !this.isBookmarked;
        }
      } catch (error) {
        console.error('Error toggling bookmark:', error);
      }
    }
  }
}
</script>

<style scoped>
button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2em;
  color: #6c757d;
}

button.is-bookmarked {
  color: #ffc107;
}
</style>